import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import {
    AllPagesWrapper,
    CompleteRuleChipItem,
} from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/segmentRulesStyles";
import { noop } from "lodash";

export const AllPagesChipPlaceholder: FC<{ domain: string }> = (props) => {
    const { domain } = props;

    return (
        <AllPagesWrapper>
            <CompleteRuleChipItem
                text={`${i18nFilter()("segmentsWizard.addFilter.includePages.allPages.chip")} ${domain}`}
                onCloseItem={noop}
                isAllPagesPlaceholder={true}
                hideActionButton={true}
            />
        </AllPagesWrapper>
    );
};
